<template>
<div class="item orderpad my-account-item" v-bind:class="{open: isVisible}">
    <a class="level-1" v-on:click="isVisible = !isVisible">
        {{ name }}
    </a>
    <order-pad
      v-bind:netsuite_url="netsuite_url"
      v-bind:netsuite_app_url="netsuite_app_url"
      v-bind:enable_b2c="enable_b2c"
      v-bind:enable_b2b="enable_b2b"
      v-bind:title="name"
      @close="isVisible = false"
    >
    </order-pad>
</div>
</template>

<script>
export default {
  props: {
    enable_b2c: {},
    enable_b2b: {},
    netsuite_url: {},
    netsuite_app_url: {},
    name: String
  },
  data() {
    return {
      cartmode: false,
      isVisible : false
    };
  },
  mounted() {
    var enables = new Object();
    enables["enable_b2b"] = this.enable_b2b;
    enables["enable_b2c"] = this.enable_b2c;

    this.$store
      .dispatch("auth/isCartMode", enables)
      .then(data => {
        this.cartmode = data;
      })
      .catch(error => {});

  }
};
</script>
